// import { Injectable } from '@angular/core';
// import {
//   HttpInterceptor,
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpErrorResponse
// } from '@angular/common/http';
// import { Observable, throwError, EMPTY } from 'rxjs';
// import { catchError } from 'rxjs/operators';
// import { AuthService } from './auth.service';

// @Injectable()
// export class AppInterceptorService implements HttpInterceptor {
//   constructor(private authService: AuthService) {}

//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     const token = localStorage.getItem('access_token') || '';
//     const tid = this.authService.businessId || '';

//     const authReq = req.clone({
//       setHeaders: {
//         Authorization: `Bearer ${token}`,
//         tid: tid,
//       },
//     });

//     return next.handle(authReq).pipe(
//       catchError((error: HttpErrorResponse) => {
//         if (error.status === 0 || error.status === 598) {
//           this.authService.connectionError('');
//           return EMPTY;
//         }
//         return throwError(() => error);
//       })
//     );
//   }
// }

import { HttpInterceptorFn } from '@angular/common/http';
import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environment/environment';
import {
  Observable,
  BehaviorSubject,
  catchError,
  filter,
  finalize,
  map,
  switchMap,
  take,
  throwError,
  of
} from 'rxjs';
import { AuthService } from './auth.service';
 


 
const isExternalRequest = (request: HttpRequest<any>) => {
  return request.url.includes('blob.core.windows.net') ;
};
 
const addTokenHeader = (
  request: HttpRequest<any>,
  token: string,
  tid: string
): Observable<HttpRequest<any>> => {
 
  if (isExternalRequest(request)) {
    return of(request);
  }
 
  if (request.url.includes(environment.apiUrl)) {
        return of( request.clone({
          setHeaders: {
            Accepts: '*/*',
            Authorization: `Bearer ${token}`,
            tid: tid,
          },
        }));
  }
 
  return of(request.clone());
};
 

export const appInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);

  const router = inject(Router);
 
  const token = localStorage.getItem('access_token') || '';
     const tid = authService.businessId || '';

 
  return addTokenHeader(req, token, tid).pipe(
    switchMap((authReq) => {
      return next(authReq).pipe(
        catchError((error) => {
        //   if (
        //     error instanceof HttpErrorResponse &&
        //     !authReq.url.includes('accounts/login') &&
        //     error.status === 401
        //   ) {
        //     //return handle401Error(authReq, cacheService, authService, accountService, router, next);
        //   }
          return throwError(() => error);
        })
      );
    })
  );
};